import * as yup from "yup";

export const workflowSchema = yup.object().shape({
    workflow_name: yup
      .string()
      .required("Workflow name is required")
      .trim()
      .min(2, "Workflow name must be at least 2 characters")
      .max(50, "Workflow name must not exceed 50 characters"),
    workflow_steps: yup
      .array()
      .of(
        yup.object().shape({
          status: yup
            .string()
            .required("Step status is required")
            .trim(),
          generic_step_id: yup
            .number()
            .typeError("Please select a valid option")
            .required("Please select a valid option")
            .test('is-valid-step', 'Please select a valid option ', value => {
              return value !== null && value !== undefined && value !== '';
            }),
          workflow_step_id: yup
            .mixed()
            .nullable(),
          is_completed: yup
            .boolean()
            .default(false),
        })
      )
      .min(1, "At least one workflow step is required"),
  });